export const siteSettings = {
  name: "Trade Lance",
  link: "https://tradelance.net",
  email: "support@tradelance.net",
  appLink: "https://app.tradelance.net",
};
